export const debounce = (fn, delay) => {
  let timer;
  return (...args) => new Promise(resolve => {
    clearTimeout(timer);
    timer = setTimeout(() => resolve(fn(...args)), delay);
  });
};

export const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: '0.75rem',
    borderColor: state.isFocused ? '#4dc9be' : '#e5e7eb',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(77,201,190,0.25)' : 'none',
    '&:hover': { borderColor: '#4dc9be' },
    minHeight: '42px',
    fontSize: '0.875rem',
    backgroundColor: 'white',
  }),
  valueContainer: (base) => ({ ...base, padding: '2px 10px' }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#2d5a4a' : state.isFocused ? 'rgba(77,201,190,0.1)' : 'white',
    color: state.isSelected ? 'white' : '#1a3a36',
    fontSize: '0.875rem',
    cursor: 'pointer',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '0.75rem',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
    zIndex: 9999,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  placeholder: (base) => ({ ...base, color: '#9ca3af', fontSize: '0.875rem' }),
  singleValue: (base) => ({ ...base, color: '#1a3a36', fontSize: '0.875rem' }),
  input: (base) => ({ ...base, fontSize: '0.875rem', color: '#1a3a36' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, color: '#9ca3af', padding: '0 8px' }),
  clearIndicator: (base) => ({ ...base, color: '#9ca3af', '&:hover': { color: '#ef4444' }, padding: '0 4px' }),
  loadingMessage: (base) => ({ ...base, fontSize: '0.875rem', color: '#9ca3af' }),
  noOptionsMessage: (base) => ({ ...base, fontSize: '0.875rem', color: '#9ca3af' }),
};
